import React from "react";
import { lazy, Suspense } from "react";
import MainLayout from "../Layout/MainLayout";
import AuthLayout from "../Layout/AuthLayout";
import { useRoutes } from "react-router-dom";
import Login from "../Components/auth/login";

const Loader = Component => props =>
    (
        <Suspense fallback={<Loader />}>
            <Component {...props} />
        </Suspense>
    );

const Home = Loader(lazy(() => import("../Components/Common/Home")));
const Profile = Loader(
    lazy(() => import("../Components/AdminProfile/Profile"))
);
const Investor_Dashboard = Loader(
    lazy(() =>
        import(
            "../Components/Investory/PropInvestorDashboard/InvestorDashboard"
        )
    )
);
const DashInvestPoolDetails = Loader(
    lazy(() =>
        import("../Components/Investory/PropInvestorDashboard/DashInvestPool")
    )
);
const SupportChat = Loader(
    lazy(() => import("../Components/Investory/InvestoryRelations/SupportChat"))
);
const TicketModal = Loader(
    lazy(() => import("../Components/support/TicketModal"))
);

const TicketListing = Loader(
    lazy(() => import("../Components/support/TicketListing"))
);

const Transaction = Loader(
    lazy(() => import("../Components/Transactions/Transaction"))
);
const PaymentRequest = Loader(
    lazy(() => import("../Components/Transactions/PaymentRequest"))
);
const TransactionDetails = Loader(
    lazy(() => import("../Components/Transactions/TransactionDetails"))
);
const AddUser = Loader(
    lazy(() => import("../Components/User_Management/AddUser"))
);

const UserManagementViewUserDetails = Loader(
    lazy(() =>
        import("../Components/User_Management/DetailsUserManagementViewUser")
    )
);

const PropertyListing = Loader(
    lazy(() => import("../Components/PropertyListing/PropertyListing"))
);
const EditProperty = Loader(
    lazy(() => import("../Components/PropertyListing/EditProperty"))
);
const AddProperty = Loader(
    lazy(() => import("../Components/PropertyListing/AddPropertyForm/index"))
);

// const Agent = Loader(
// lazy(() => import("../Components/User_Management/Agent/Agent"))
// );
// const AgentList = Loader(
//   lazy(() => import("../Components/User_Management/Agent/AgentList"))
// );

const UserManagement = Loader(
    lazy(() => import("../Components/User_Management/UserManagement"))
);
const AccountsManagement = Loader(
    lazy(() => import("../Components/Accounts_Management/AccountsManagement"))
);

const ViewEvaluatorKyc = Loader(
    lazy(() => import("../Components/User_Management/CardUserManagement"))
);

const VerificationRequest = Loader(
    lazy(() => import("../Components/PropertyListing/VerificationRequest"))
);

const DocumentVerification = Loader(
    lazy(() => import("../Components/PropertyListing/DocumentVerification"))
);
const ResetPassword = Loader(
    lazy(() => import("../Components/auth/ResetPassword"))
);
const RoleManage = Loader(
    lazy(() => import("../Components/Manager_Role/RoleManage"))
);

const EditRoleManage = Loader(
    lazy(() => import("../Components/Manager_Role/EditRoleManage"))
);

const PropertyVerification = Loader(
    lazy(() =>
        import("../Components/Property_Verification/PropertyVerification")
    )
);
const AddPropertyVerification = Loader(
    lazy(() =>
        import("../Components/Property_Verification/AddPropertyVerification")
    )
);
const ViewPropertyVerification = Loader(
    lazy(() =>
        import("../Components/Property_Verification/ViewPropertyVerification")
    )
);
const ViewPropertyListing = Loader(
    lazy(() => import("../Components/PropertyListing/ViewPropertyListing"))
);

const UserSubscription = Loader(
    lazy(() => import("../Components/Subscription/SubscriptionPlan"))
);

const AddUserSub = Loader(
    lazy(() => import("../Components/Subscription/User/Add/AddOrEditUserSub"))
);

const AddManager = Loader(
    lazy(() => import("../Components/Managers/AddManager"))
);

const ViewManager = Loader(
    lazy(() => import("../Components/Managers/ViewManager"))
);
const EditManger = Loader(
    lazy(() => import("../Components/Managers/EditMager"))
);
const Manager = Loader(lazy(() => import("../Components/Managers/Manager")));

const InvestorVerification = Loader(
    lazy(() =>
        import("../Components/investorVerification/InvestorVerification")
    )
);
const Investors = Loader(
    lazy(() => import("../Components/Investory/Investors"))
);

const CreatePool = Loader(
    lazy(() =>
        import("../Components/Investory/Investors/CreatePool/CreatePool")
    )
);
const InvestoryManagment = Loader(
    lazy(() => import("../Components/Investory/InvestoryManagment/index"))
);
const InvestoryRelations = Loader(
    lazy(() => import("../Components/Investory/InvestoryRelations/index"))
);
const EditPool = Loader(
    lazy(() => import("../Components/Investory/Investors/EditPool/index"))
);
const PoolManagment = Loader(
    lazy(() => import("../Components/Investory/Investors/Pools/PoolManagments"))
);
const InvestorInPool = Loader(
    lazy(() => import("../Components/Investory/Investors/Pools/InvestorInPool"))
);
const InvestorDetails = Loader(
    lazy(() =>
        import("../Components/Investory/Investors/Investor/InvestorDetails")
    )
);
const PropertyFinalization = Loader(
    lazy(() =>
        import("../Components/Investory/Investors/Pools/PropertyFinalization")
    )
);
const Notifications = Loader(
    lazy(() => import("../Components/Common/Notification"))
);

function Router() {
    let element = useRoutes([
        {
            element: <AuthLayout />,
            children: [
                { path: "/", element: <Login /> },
                { path: "/reset-password", element: <ResetPassword /> },
                {
                    element: <MainLayout />,
                    children: [
                        { path: "/Dashboard", element: <Home /> },
                        {
                            path: "/Prop-InvestorDashboard",
                            element: <Investor_Dashboard />
                        },
                        {
                            path: "/DashInvestPool",
                            element: <DashInvestPoolDetails />
                        },
                        { path: "/profile", element: <Profile /> },
                        {
                            path: "/investor/notifications",
                            element: <Notifications />
                        },
                        // Transactions
                        { path: "/transactions", element: <Transaction /> },
                        {
                            path: "/paymentrequest",
                            element: <PaymentRequest />
                        },
                        { path: "/support/", element: <TicketListing /> },
                        {
                            path: "/support/:ticketId",
                            element: <TicketModal />
                        },
                        { path: "/supportchat/", element: <SupportChat /> },
                        {
                            path: "/user-payment-details/:userid",
                            element: <TransactionDetails />
                        },
                        {
                            path: "/user-list/:userRole/addUser/:id?",
                            element: <AddUser />
                        },
                        {
                            path: "/userManagement/:userRole/viewUser/:id",
                            element: <ViewEvaluatorKyc />
                        },
                        {
                            path: "/investorVerification",
                            element: <InvestorVerification />
                        },
                        {
                            path: "/investors",
                            element: <Investors />
                        },
                        {
                            path: "/investors/createpool",
                            element: <CreatePool />
                        },
                        {
                            path: "/userManagement/:userRole/viewUser/:id/details",
                            element: <UserManagementViewUserDetails />
                        },

                        {
                            path: "/property-listing",
                            element: <PropertyListing />
                        },
                        {
                            path: "/view-propertylisting/:id",
                            element: <ViewPropertyListing />
                        },

                        { path: "/add-property", element: <AddProperty /> },
                        { path: "/edit-property", element: <EditProperty /> },

                        {
                            path: "/property-Verification",
                            element: <PropertyVerification />
                        },
                        {
                            path: "/add-propertyverification",
                            element: <AddPropertyVerification />
                        },
                        {
                            path: "/view-propertyverification/:id",
                            element: <ViewPropertyVerification />
                        },

                        { path: "/RoleManage", element: <RoleManage /> },

                        {
                            path: "/edit-roleManage/:id",
                            element: <EditRoleManage />
                        },

                        {
                            path: "/documentVerification",
                            element: <DocumentVerification />
                        },
                        //subscription
                        {
                            path: "/subscription",
                            element: <UserSubscription />
                        },
                        {
                            path: "/EditSubscription/:userRole/add/:id?",
                            element: <AddUserSub />
                        },
                        {
                            path: "/subscription/add_subscription",
                            element: <AddUserSub />
                        },
                        {
                            path: "/add-manager/:id?",
                            element: <AddManager />
                        },

                        {
                            path: "/view-manager/:id",
                            element: <ViewManager />
                        },
                        { path: "/edit-manager/:id", element: <EditManger /> },
                        {
                            path: "/managers",
                            element: <Manager />
                        },
                        {
                            path: "/verification-request",
                            element: <VerificationRequest />
                        },
                        {
                            path: "userManagement/:userRole",
                            element: <UserManagement />
                        },
                        {
                            path: "accountsManagement/:userRole",
                            element: <AccountsManagement />
                        },
                        {
                            path: "userManagement/:userRole/addUser/:id?",
                            element: <AddUser />
                        },
                        {
                            path: "/investors/management",
                            element: <InvestoryManagment />
                        },
                        {
                            path: "/investors/investor-details/:id",
                            element: <InvestorDetails />
                        },
                        {
                            path: "/investors/pools/pool-management/:id",
                            element: <PoolManagment />
                        },
                        {
                            path: "/investors/relations",
                            element: <InvestoryRelations />
                        },
                        {
                            path: "/pool/investors/:id",
                            element: <InvestorInPool />
                        },
                        {
                            path: "/pool/property_finalization/",
                            element: <PropertyFinalization />
                        },
                        {
                            path: "/investors/Pools/edit-pool/:id",
                            element: <EditPool />
                        },
                        {
                            path: "/view-evaluator/:id",
                            element: <ViewEvaluatorKyc />
                        }

                        // { path: "/edit-evaluatorkyc/:id", element: <EditAgentKyc /> },
                        // { path: "/view-evaluator/:id", element: <ViewAgentKyc /> },
                        // { path: "/evaluator", element: <HigherReq /> },
                    ]
                }
            ]
        }
    ]);

    return element;
}

export default Router;
